/* eslint-disable */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import DenunciaForm from './DenunciaForm'
import DetalharDenuncia from './DetalharDenuncia'
import * as mensagemActions from './actions/mensagemActions'
import * as anexosActions from './actions/anexosActions'
import Alert from 'react-s-alert';
import  './css/detalharHistorico.css'
import $ from 'jquery';
import ConfigD from './util/ConfigD';
import Helpers from './util/Helpers'

import Dropzone from 'react-dropzone'

class DetalharHistorico extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            txtDenunciaDocumento: '',
            txtDenunciaEvidencia: '',
            txtDenunciaLideranca: '',
            txtDenunciaMeioConhecimento: '',
            txtDenunciaQuandoOnde: '',
            txtDenunciaTempo: '',
            txtDenunciaTestemunha: '',
            txtDenunciaValor: '',
            txtDenunciaAmeaca: '',
            accept: '.pdf, .jpg, .png, .mp4, .avi',
            files: [],
            dropzoneActive: false,
            existeDenuncia: false,

        };

        this.tramitar = this.tramitar.bind(this);
        this.validaForm = this.validaForm.bind(this);

        this.fechar = this.fechar.bind(this);
        this.onChangetxtDenunciaDocumento = this.onChangetxtDenunciaDocumento.bind(this);
        this.onChangetxtDenunciaEvidencia = this.onChangetxtDenunciaEvidencia.bind(this);
        this.onChangetxtDenunciaLideranca = this.onChangetxtDenunciaLideranca.bind(this);
        this.onChangetxtDenunciaMeioConhecimento = this.onChangetxtDenunciaMeioConhecimento.bind(this);
        this.onChangetxtDenunciaQuandoOnde = this.onChangetxtDenunciaQuandoOnde.bind(this);
        this.onChangetxtDenunciaTempo = this.onChangetxtDenunciaTempo.bind(this);
        this.onChangetxtDenunciaTestemunha = this.onChangetxtDenunciaTestemunha.bind(this);
        this.onChangetxtDenunciaValor = this.onChangetxtDenunciaValor.bind(this);
        this.onChangetxtDenunciaAmeaca = this.onChangetxtDenunciaAmeaca.bind(this);
        this.onChangeDenuncia = this.onChangeDenuncia.bind(this);
        this.getMeiosConhecimentoDenunciaSelecionada = this.getMeiosConhecimentoDenunciaSelecionada.bind(this);

        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onDropRejected = this.onDropRejected.bind(this);
        this.anexar = this.anexar.bind(this);
        this.applyMimeTypes = this.applyMimeTypes.bind(this);
        this.removerAnexo = this.removerAnexo.bind(this);

    }

    componentDidMount() {
        
    }

    onChangeDenuncia() {
        this.setState({ existeDenuncia: true })
    }
    getMeiosConhecimentoDenunciaSelecionada(val) {
        this.setState({ meioConhecimentoDenuniaSelecioanda: val, existeDenuncia: true })
    }
    onChangetxtDenunciaDocumento(e) {
        this.setState({ txtDenunciaDocumento: e, existeDenuncia: true });
    }

    onChangetxtDenunciaEvidencia(e) {
        this.setState({ txtDenunciaEvidencia: e });
    }

    onChangetxtDenunciaLideranca(e) {
        this.setState({ txtDenunciaLideranca: e, existeDenuncia: true });
    }

    onChangetxtDenunciaMeioConhecimento(e) {
        this.setState({ txtDenunciaMeioConhecimento: e, existeDenuncia: true });
    }

    onChangetxtDenunciaQuandoOnde(e) {
        this.setState({ txtDenunciaQuandoOnde: e, existeDenuncia: true });
    }

    onChangetxtDenunciaTempo(e) {
        this.setState({ txtDenunciaTempo: e, existeDenuncia: true });
    }

    onChangetxtDenunciaTestemunha(e) {
        this.setState({ txtDenunciaTestemunha: e, existeDenuncia: true });
    }

    onChangetxtDenunciaValor(e) {
        this.setState({ txtDenunciaValor: e, existeDenuncia: true });
    }

    onChangetxtDenunciaAmeaca(e) {
        this.setState({ txtDenunciaAmeaca: e,  existeDenuncia: true });
    }

    fechar(event, msg) {

        //console.log('historico ', historico);
            
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        if ($('.detailFoot').hasClass('slide-up')) {
            $('.detailFoot').addClass('slide-down', 1000, 'easeOutBounce');
            $('.detailFoot').removeClass('slide-up');
        } else {
            $('.detailFoot').removeClass('slide-down');
            $('.detailFoot').addClass('slide-up', 1000, 'easeOutBounce');
        }
        this.anexar(msg);
      


    }

    componentWillReceiveProps(nextProps) {
        //  if (!$.isEmptyObject(nextProps.mensagem) && !$.isEmptyObject(this.props.mensagem) && (this.props.mensagem !== nextProps.mensagem)) {
        //         debugger;
        //         console.log('mensagem cadastrada --> ', nextProps.mensagem)    
        //      //this.anexar(nextProps.mensagem);
         //}
    }

    tramitar(event) {
        
       
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (this.validaForm()) {
            // copiar o mensagem para o mensagemVO
            // atribuir valores de tela. 
            var relato = this.refs.txtMensagem.value;
            
            var mDenuncia = {};
            if (!$.isEmptyObject(this.props.historico)
                && !$.isEmptyObject(this.props.mensagem)
                && !$.isEmptyObject(this.props.historico.mClassificacaoOperador)
                && this.props.historico.mClassificacaoOperador.mIdClassificacao === 1){

                mDenuncia = {
                    mIdDenuncia: this.props.mensagem.mDenuncia!==null?this.props.mensagem.mDenuncia.mIdDenuncia:0,
                    mAmeaca: this.state.txtDenunciaAmeaca,
                    mDocumento: this.state.txtDenunciaDocumento,
                    mEvidencia: this.state.txtDenunciaEvidencia,
                    mLideranca: this.state.txtDenunciaLideranca,
                    mQuandoOnde: this.state.txtDenunciaQuandoOnde,
                    mTestemunha: this.state.txtDenunciaTestemunha,
                    mValor: this.state.txtDenunciaValor,
                    mTempoConhecimento: this.state.txtDenunciaTempo,
                    mMeioConhecimento: this.state.meioConhecimentoDenuniaSelecioanda
                };
            }
            else {
                mDenuncia = null;
            }
            
            var mensagemVO =
                Object.assign({}, this.props.mensagem, {
                    mTextoMensagem: relato,
                    mTextoMensagemRTF: null,
                    mTextoMensagemHTML: relato,
                    mDenuncia: mDenuncia
                })
            
            $(this.refs.errorTxt).hide();
            var msgTramitar = {
                mensagemVO: mensagemVO,
                operadorVO: null,
                assuntoVO: null,
                estruturaOrganizacionalVO: this.props.historico.mEstruturaOrganizacional,
                registroHistoricoVisivel: true,
                situacaoMensagem: 10,//complemento informado
                classificacao: null,
                estruturaExternaVO: null,
                grupoTratamentoVO: null,
                movimentacaoMensagem: null
            }
            
            this.props.actions.tramitar(msgTramitar)
            .then(() => this.fechar(undefined, mensagemVO))
            .catch(error => {
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });
                });
                
        }

    }

    validaForm() {
        
        var valido = true;
        var mensagem = this.refs.txtMensagem.value;
        if (mensagem === '') {
            $(this.refs.errMensagem).show();
            valido = false;
        }
        if (!$.isEmptyObject(this.props.historico) 
                && !$.isEmptyObject(this.props.mensagem)
                && !$.isEmptyObject(this.props.historico.mClassificacaoOperador)
                && this.props.historico.mClassificacaoOperador.mIdClassificacao === 1 
                && this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao.mIdSituacao === 9 ){//denúncia

            if (this.state.txtDenunciaQuandoOnde === '') {
                $(this.refs.errQuandoOnde).show();
                valido = false;
            }

            if (this.state.txtDenunciaTestemunha === '') {
                $(this.refs.errTestemunha).show();
                valido = false;
            }

            if (this.state.txtDenunciaTempo === '') {
                $(this.refs.errTempo).show();
                valido = false;
            }
            

            if (this.state.txtDenunciaLideranca === '') {
                $(this.refs.errLideranca).show();
                valido = false;
            }
            
            if (this.state.txtDenunciaAmeaca === '') {
                $(this.refs.errAmeaca).show();
                valido = false;
            }



        }


        return valido;
    }


    removerAnexo(idx) {
        
        
        var filesTemp = this.state.files;
        filesTemp.splice(idx,1);
        this.setState({
            files: filesTemp
        });
    }
    
    onDragEnter() {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave() {
        this.setState({
            dropzoneActive: false
        });
    }

    onDropRejected = () => {
    }

    onDrop(files) {
        
        var filesTemp = this.state.files;

        files.map((f, index) => {
            filesTemp.push(f);
        })
        this.setState({
            files: filesTemp,
            dropzoneActive: false
        });
        //console.log('files', filesTemp);
    }

    applyMimeTypes(event) {
        this.setState({
            accept: event.target.value
        });
    }

    anexar(mensagem) {
        if(!$.isEmptyObject(mensagem) && this.state.files.length>0){
            if (this.state.files.length > 0) {
                Helpers.apresentarSpinner('Anexando arquivo');
                for (let index = 0; index < this.state.files.length; index++) {
                    const element = this.state.files[index];
                    //Helpers.apresentarTxt2(element.name);
                    var visivel = "1";
                    this.props.actionsAnexos.anexar(
                        mensagem.mAtendimento.mIdAtendimento,
                        0, 
                        element,
                        visivel
                    ).catch(error => {
                        Helpers.removerSpinner();
                        Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                            position: 'top-right',
                            effect: 'slide',
                            offset: 172,
                            timeout: 5000
                        });
                    });;
                }
                Helpers.removerSpinner();
                this.setState({
                    files: []
                });
            }
    
        }

    }

    render() {
        // 
        // //console.log('detalhar - mensagem ', this.props.mensagem)
        // //console.log('historico - detalhar histórico ', this.props.historico)
        const { accept, files, dropzoneActive } = this.state;
        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '2.7em 0',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            color: '#fff'
        };


        var lista = (
            <ul>
                {
                    files.map((f, index) => {
                        
                        return <li key={index} >{f.name} - {f.size} bytes <i className="fa fa-times-circle excluir"  onClick={()=>this.removerAnexo(index)}></i></li> 
                    })
                }
            </ul>
        );

        var txtMensagem = '';
        var img = <img title="Ouvidoria" src={ConfigD.getServerBase() + "/img/timeline/imgOuvidoria.png"} /> 
        var elem = document.getElementById('linhaCard');

        if (!$.isEmptyObject(this.props.historico) && (this.props.historico.mSituacao.mIdSituacao === 1 || this.props.historico.mSituacao.mIdSituacao === 10)) {
            img = <img title="Cliente" src={ConfigD.getServerBase() + "/img/timeline/imgCliente.png"} /> 
            elem.style = 'border-bottom-color: #8dd1e1 !important;'
        }
        else if (!$.isEmptyObject(this.props.historico)){
            elem.style = 'border-bottom-color: #2196f3 !important;'
        }
        
        var denuncia = '';
        var btnComplementar = ''
        var dropZoneGeral = ''
        if (!$.isEmptyObject(this.props.historico) 
            && this.props.historico.mHistoricoDenuncia!== null) {

            denuncia = <DetalharDenuncia {...this.props} />

        } else if (!$.isEmptyObject(this.props.historico) 
            && !$.isEmptyObject(this.props.mensagem) 
            && this.props.historico.mSituacao.mIdSituacao === 9 
            && this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao.mIdSituacao === 9 ) {
            btnComplementar = <button type="submit" onClick={this.tramitar}>Complementar informação</button>
            txtMensagem =
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                        <div className="form-group">
                            <div className="input-icon">
                                <label><b></b></label>
                                <textarea rows="6" cols="70" className="form-control" name="txtMensagem" id='txtMensagem' placeholder="" ref='txtMensagem' id='txtMensagem' name='txtMensagem' />
                                <span ref='errMensagem' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                            </div>
                        </div>
                    </div>
                    
                </div>
            dropZoneGeral = (
                <div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 drop">
                        <Dropzone style={{ position: "relative" }} accept={accept} onDrop={this.onDrop.bind(this)} onDragEnter={this.onDragEnter.bind(this)} onDragLeave={this.onDragLeave.bind(this)}>
                            {dropzoneActive && <div style={overlayStyle}>Solte para anexar</div>}
                            <div className='centerText'> <label ><b>Clique ou arraste nessa área para anexar:</b></label></div>
                            <div className='centerText'> <label ><b><i className="fa fa-paperclip fa-2x" aria-hidden="true"></i></b></label></div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 size">
                            </div>
                        </Dropzone>
                        <span ref='errorSizeDrop' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                            <div className="input-icon">
                                <label style={{ display: 'none' }}><b>Arquivos anexados:</b></label>
                                {lista}
                            </div>
                        </div>
                    </div>
                </div>);

            if (!$.isEmptyObject(this.props.historico) 
                && !$.isEmptyObject(this.props.mensagem)
                && !$.isEmptyObject(this.props.historico.mClassificacaoOperador)
                && this.props.historico.mClassificacaoOperador.mIdClassificacao === 1 
                && this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao.mIdSituacao === 9 ){//denúncia
                    
                    denuncia = <DenunciaForm {...this.props}
                        onChangetxtDenunciaDocumento={this.onChangetxtDenunciaDocumento}
                        onChangetxtDenunciaEvidencia={this.onChangetxtDenunciaEvidencia}
                        onChangetxtDenunciaLideranca={this.onChangetxtDenunciaLideranca}
                        onChangetxtDenunciaMeioConhecimento={this.onChangetxtDenunciaMeioConhecimento}
                        onChangetxtDenunciaQuandoOnde={this.onChangetxtDenunciaQuandoOnde}
                        onChangetxtDenunciaTempo={this.onChangetxtDenunciaTempo}
                        onChangetxtDenunciaTestemunha={this.onChangetxtDenunciaTestemunha}
                        onChangetxtDenunciaValor={this.onChangetxtDenunciaValor}
                        onChangetxtDenunciaAmeaca={this.onChangetxtDenunciaAmeaca}
                        getMeiosConhecimentoDenunciaSelecionada={this.getMeiosConhecimentoDenunciaSelecionada}
                        
                    />
            }
        }


        return (
            <form method="post" id='tramitar' >

            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 detailFoot">
                <div className="tools" onClick={this.fechar}>
                    <i className='fa fa-times' aria-hidden="true" title='Fechar detalhamento' ></i>
                </div>
                <div className="comment-wrapper">
                    <h3 className="title">{!$.isEmptyObject(this.props.historico) ? this.props.historico.mSituacao.mDescricao : ''}</h3>
                    <div className="clearfix"></div>
                    <div className="comments-sec tituloComentario">
                        <ol className="commentlist">
                            <li>
                                <div className="comment" id="1">
                                    <div className="avatar">
                                        {img}
                                    </div>
                                    <div id='linhaCard' className="comment-des tituloComentario ">
                                        <div className="arrow-comment">
                                        </div>
                                        <div className="comment-by">
                                            <span className="date dateFont">{!$.isEmptyObject(this.props.historico) ? moment(this.props.historico.mDataEnvio).format('DD/MM/YYYY HH:mm:ss') : ''}</span>
                                        </div>
                                       
                                        <div dangerouslySetInnerHTML={{ __html: this.props.texto }}/>  
                                        {txtMensagem}
                                        {dropZoneGeral}
                                        {denuncia}
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            {btnComplementar}
                                        </div>
                                    </div>
                                    <div className="clearfix">
                                    </div>
                                </div>
                                <div className="clearfix">
                                </div>
                            </li>
                        </ol>
                    </div>
                    <div className="clearfix">
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {''}
                </div>
            </div>
            </form>
        );
    }
}


// DetalharHistorico.protoType = {
//     actions: PropTypes.object.isRequired
// }
// DetalharHistorico.contextTypes = {
//   router: React.PropTypes.object
// };

function mapStateToProps(state, ownProps){
    
    return {
        //mensagem: state.mensagem,
    };
}

function mapDispatchToProps(dispatch) {
    return {

        actions: bindActionCreators(mensagemActions, dispatch),
        actionsAnexos: bindActionCreators(anexosActions, dispatch),
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(DetalharHistorico);



/** WEBPACK FOOTER **
 ** ./src/components/DetalharHistorico.js
 **/